require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./my-l-pmusings.json") })
        }
      }, "path---my-l-pmusings");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---my-l-pmusings!./.cache/json/my-l-pmusings.json
// module id = 1180
// module chunks = 231608221292675